import produce from 'immer'
import * as actionTypes from '../actions/actionTypes'
import { actionTypes as accountActType } from '../actions/accountActions'
import { actionTypes as orderActionTypes } from '../actions/orderActions'

const initialState = {
    loadingInit: 0,
    loading: 0,
    timerSuccess: false,
    showLoginForm: false,
    lastActive: '',
    agreeOvertime: false
}

const AppReducer = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case actionTypes.LOADING_INIT: {
                const newLoad =
                    draft.loadingInit + (action.payload.loading ? 1 : -1)
                draft.loadingInit = Math.max(0, newLoad)
                break
            }
            case actionTypes.TIMER_SUCCESS: {
                draft.timerSuccess = true
                break
            }
            case actionTypes.SET_LAST_ACTIVE: {
                draft.lastActive = action.payload
                break
            }
            case actionTypes.LOADING: {
                // const newLoad = draft.loading + (action.payload.loading ? 1 : -1)
                // draft.loading = Math.max(0, newLoad)
                draft.loading = action.payload.loading
                break
            }
            case actionTypes.SHOW_LOGIN: {
                const { isOpen } = action.payload
                draft.showLoginForm = isOpen
                break
            }
            case accountActType.LOGIN_SUCCESS: {
                draft.showLoginForm = false
                break
            }
            case actionTypes.RESET_LOADING: {
                draft.loadingInit = 0
                draft.loading = 0
                break
            }
            case actionTypes.AGREE_OVERTIME: {
                draft.agreeOvertime = true
                break
            }
            case orderActionTypes.SET_ORDER_METHOD:
            case orderActionTypes.SET_DELIVER_POSITION:
            case orderActionTypes.ADD_GROUP_ORDER:
            case orderActionTypes.DEL_GROUP_ORDER:
            case orderActionTypes.ADD_FOOD_GROUP:
            case orderActionTypes.UPDATE_AMOUNT:
            case orderActionTypes.ADD_FOOD_TO_CART: {
                draft.lastActive = new Date().getTime()
                break
            }
            default:
                return state
        }
    })

export default AppReducer
